Ext.define('SA.lq.GridColumnCfgFactory', {
    constructor({getAttributeColumnHeaderHtml}) {
        this.getAttributeColumnHeaderHtml = getAttributeColumnHeaderHtml;
    },

    getCfgs({sort, attributeIds}) {
        var hasSort = attributeId => sort.hasAttributeId(attributeId),
            getSort = attributeId => hasSort(attributeId) ? sort : null,
            getCls = attributeId => !hasSort(attributeId) ? 'sa-lq-grid-column' : `sa-lq-grid-column sa-report-grid-sorted-${sort.getDirection()}`;

        return [
            {
                dataIndex: 'rank',
                align: 'right',
                width: 58
            }, {
                dataIndex: 'name',
                cls: getCls('name'),
                contentWidth: 250,
                encodeCells: false,
                forceRender: true,
                sort: getSort('name'),
                text: 'Location',
                width: 150
            },
            ...attributeIds.map(attributeId => ({
                dataIndex: attributeId,
                align: 'right',
                autoWidth: 215,
                cls: getCls(attributeId),
                contentWidth: true,
                encodeText: false,
                sort: getSort(attributeId),
                text: this.getAttributeColumnHeaderHtml(attributeId),
                width: 120
            }))
        ];
    }
});